import { render, staticRenderFns } from "./AcctLedger.vue?vue&type=template&id=50abe2b9&"
import script from "./AcctLedger.vue?vue&type=script&lang=js&"
export * from "./AcctLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports